// src/App.js
import React from 'react';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import Contact from './components/Contact/Contact';
import './App.css';

Amplify.configure(awsExports);

function App() {
  return (
    <div className="App">
      <Contact />
    </div>
  );
}

export default App;
